import {UpdateAction, UpdateType} from "../../gd/manager/delta-handler/types";
import Resources from "../resources";
import Meeting from "../../model2/meeting/meeting";


export default function resourcesProcessUpdates(resources:Resources, updates:(false|undefined|UpdateAction)[]) {

    let anyChanges = false


    _.map(updates, (update) => {

        if (!update) return

        let isChanged = false
        const payload = update.payload

        switch (update.updateType) {

            case UpdateType.MEETING_DELTA:
            {
                const meeting: Meeting | undefined = resources.meetings?.get(payload.id)
                if (meeting) isChanged = meeting.applyDelta(payload)     // apply delta for subtask
            }
                break

            case UpdateType.MEETING_DELETE:
            {
                const meeting : Meeting|undefined = resources.meetings?.get(payload.id)
                if (meeting) {
                    isChanged = true
                    resources.meetings?.remove(payload.id)
                }
            }
                break

            case UpdateType.MEETING_NEW:
            {
                isChanged = true
                const meeting : Meeting = new Meeting(payload)
                resources.meetings?.add(meeting)
            }
                break

            case UpdateType.EXPENSE_NEW:
            case UpdateType.EXPENSE_DELTA:
            case UpdateType.EXPENSE_DELETE:
                if (resources.expenses?.processUpdate(update)) {
                    isChanged = true
                }
                break


            default:
                break
        }


        if (isChanged) anyChanges = true
    })

    if (anyChanges) {
        // console.log("resources collection has changed .... ")
        resources.deltaHandlerCallback && resources.deltaHandlerCallback()
    }
}